<template>
  <div class="v-login-accout"
    :class="{
      'error': errorTxt,
      'resize': isResize && isNeedAgreement && isNeedSelectAccount && isNeedImgCaptcha
    }"
    :env="env"
  >
    <error-text v-if="errorTxt" :text="errorTxt"></error-text>
    <ul class="v-login-accout__box" :env="env">
      <li @click.stop="">
        <div class="label" :class="{ 'active': validUserName }">手机号码、用户名或邮箱</div>
        <input type="text" maxlength="20"
          :class="{ 'active': validUserName }"
          v-model.trim="form.username"
          @focus.stop="focus.username = true"
          @blur.stop="checkUsername(true)"
          @keyup.stop="dueUsername"
          @paste.stop="dueUsername"
        />
        <quick-clear v-if="useOptions.isQuickClear && form.username && focus.username"
          @clearTxt="clearUsername"></quick-clear>
        <div class="suggest-popop-status"
          v-else-if="useOptions.isRemember"
          :class="{ on: focus.username }"
          @click="focus.username = !focus.username"
        >
        </div>
        <div class="suggest-popop-wrap"
          v-if="useOptions.isRemember"
          :class="{ show: this.focus.username && rememberList.length }"
        >
          <ul class="suggest-popop">
            <li
              v-for="user in rememberList"
              @click="selectSuggestion(user)"
              :key="user.username">{{user.username}}<i @click.stop="delSuggesstionItem(user)">×</i>
              </li>
          </ul>
        </div>
        <!-- <error-tips v-if="tips.username" :tips="tips.username"></error-tips> -->
      </li>
      <li v-if="isNeedSelectAccount">
        <div class="label" :class="{ 'active': form.account }">当前账号</div>
        <input :class="{ 'active': form.account }"
          v-model.trim="form.account"
          readonly="true"
        />
        <!-- <error-tips v-if="tips.account" :tips="tips.account"></error-tips> -->
        <change-account
          ref="ChangeAccount"
          @selectItem="selectAccount"
          :items="accountItems"
        >
        </change-account>
      </li>
      <li>
        <div class="label" :class="{ 'active': validPassword }">密码</div>
        <input :type="showPwd ? 'text' : 'password'" maxlength="20"
          :class="{ 'active': validPassword }"
          v-model.trim="form.password"
          @focus.stop="focus.password = true"
          @blur.stop="checkPassword(true)"
          @keyup.stop="duePassword"
        />
        <quick-clear v-if="useOptions.isQuickClear && form.password && focus.password"
          :right="24"
          @clearTxt="clearPassword"></quick-clear>
        <show-pwd @togglePwd="togglePwd"></show-pwd>
        <!-- <error-tips v-if="tips.password" :tips="tips.password"></error-tips> -->
      </li>
      <li class="captcha-li" v-if="isNeedImgCaptcha">
        <div class="captcha-ipt">
          <div class="label" :class="{ 'active': validImgCaptcha }">图形验证码</div>
          <input type="text" maxlength="5"
            :class="{ 'active': validImgCaptcha }"
            v-model.trim="form.imgCaptcha"
            @focus.stop="focus.imgCaptcha = true"
            @blur.stop="checkImgCaptcha(true)"
            @keyup.stop="dueImgCaptcha"
          />
          <quick-clear v-if="useOptions.isQuickClear && form.imgCaptcha && focus.imgCaptcha"
            @clearTxt="clearImgCaptcha"></quick-clear>
          <!-- <error-tips v-if="tips.imgCaptcha" :tips="tips.imgCaptcha"></error-tips> -->
        </div>
        <div class="captcha-img" @click="refreshImgCaptcha">
          <img :src="imgCaptchaUrl" alt="" />
        </div>
      </li>
      <li class="links-li">
        <login-links
          :env="useOptions.env"
          :isRegister="useOptions.isRegister"
          :isFindPwd="useOptions.isFindPwd"
          :isRemember="useOptions.isRemember"
          :isRememberChecked="isRememberChecked"
          @rememberMe="rememberMe"
          v-on="$listeners" />
      </li>
      <li class="agreement-li" v-if="isNeedAgreement">
        <agreement :graph="graph" @toggleAgreement="toggleAgreement" />
      </li>
      <li class="btn-li">
        <a class="btn" href="javascript:void(0)"
          :class="{ 'disable': isBtnDisable }"
          @click="toLogin">
          <span v-if="isLoading && useOptions.isBtnStatus">登录中<i class="dot"><b>...</b></i></span>
          <span v-else>登录</span>
        </a>
      </li>
    </ul>
  </div>
</template>

<script>
import JSEncrypt from 'jsencrypt';
import defaults from './libs/defaults';
import { setStorage, getStorage } from './libs/utils';
import {
  apiLogin,
  apiNeedCaptcha,
  apiUserInfoByMobile,
  apiAgreement,
} from './libs/service';
import {
  ENV_API_HOST,
  ACCOUNT_TYPE,
  ENCRYPT_PUBLIC_KEY,
  ENCRYPT_PRIVATE_KEY,
} from './libs/constants';
import {
  unValidName,
  unValidPwd2,
  isMobilePhone,
  unValidImgCaptcha,
  unValidUserAccount,
  cmdRSAEncrypt,
  unValidAgreement,
} from './libs/validate';
import logger from './libs/logger';
import ChangeAccount from './components/ChangeAccount.vue';
// import ErrorTips from './components/ErrorTips.vue';
import ErrorText from './components/ErrorText.vue';
import Agreement from './components/Agreement.vue';
import ShowPwd from './components/ShowPwd.vue';
import LoginLinks from './components/LoginLinks.vue';
import QuickClear from './components/QuickClear.vue';

export default {
  name: 'v-login-account',
  props: {
    options: { type: Object, default: () => ({}) },
    isResize: { type: Boolean, default: false },
  },
  components: {
    ChangeAccount,
    // ErrorTips,
    ErrorText,
    Agreement,
    ShowPwd,
    LoginLinks,
    QuickClear,
  },
  data() {
    return {
      form: {
        username: '',
        password: '',
        account: '',
        usernameEncrypt: '',
        imgCaptcha: '',
        isAgreement: 1,
        loginType: ACCOUNT_TYPE,
      },
      tips: {
        username: '',
        password: '',
        account: '',
        imgCaptcha: '',
        agreement: '',
      },
      focus: {
        username: false,
        password: false,
        account: false,
        imgCaptcha: false,
      },
      isNeedSelectAccount: false,
      isNeedImgCaptcha: false,
      isNeedAgreement: false,
      isLoading: false,
      showPwd: false,
      isRememberChecked: false,
      rememberList: [],
      imgCaptchaUrl: '',
      RememberEncrypt: new JSEncrypt(),
      accountItems: [],
      errorTxt: '',
    };
  },
  computed: {
    useOptions() {
      return Object.assign({}, defaults, this.options);
    },
    env() {
      this.isNeedCaptcha();
      return this.useOptions.env;
    },
    graph() {
      return ENV_API_HOST[this.useOptions.env].graph;
    },
    isBtnDisable() {
      if (!this.useOptions.isBtnStatus) {
        return false;
      }
      if (this.form.username && this.form.password
        && (!this.isNeedImgCaptcha || (this.isNeedImgCaptcha && this.form.imgCaptcha))
        && (!this.isNeedAgreement || (this.isNeedAgreement && this.form.isAgreement))) {
        return false;
      }
      return true;
    },
    validUserName() {
      return this.focus.username || this.form.username;
    },
    validPassword() {
      return this.focus.password || this.form.password;
    },
    validImgCaptcha() {
      return this.focus.imgCaptcha || this.form.imgCaptcha;
    },
  },
  created() {
    // 获取记录账号记录列表
    if (this.useOptions.isRemember) {
      this.RememberEncrypt.setPublicKey(ENCRYPT_PUBLIC_KEY);
      this.RememberEncrypt.setPrivateKey(ENCRYPT_PRIVATE_KEY);
      this.rememberList = this.getRememberList();
    }
  },
  methods: {
    // 去登录
    toLogin() {
      if (this.isBtnDisable || this.isLoading) {
        return;
      }
      const errorTxt = this.checkFormDataError();
      if (errorTxt) {
        this.errorTxt = errorTxt;
        return;
      }
      const data = {
        username: this.form.username,
        password: cmdRSAEncrypt(this.form.password),
        usernameEncrypt: this.form.usernameEncrypt,
        imgCaptcha: this.form.imgCaptcha,
        loginType: this.form.loginType,
        isAgreement: this.form.isAgreement,
      };
      this.isLoading = true;
      apiLogin(
        this.graph,
        data,
        (result) => { // 登录成功
          this.isLoading = false;
          this.errorTxt = '';
          // 记住我
          const userList = this.rememberList.concat();
          let recordIdx = -1;
          userList.map((item, index) => {
            if (item.username === this.form.username) {
              recordIdx = index;
            }
            return item;
          });
          if (this.isRememberChecked) {
            if (recordIdx !== -1) { // 剔除旧记录，更换新的
              userList.splice(recordIdx, 1);
            }
            userList.push({
              username: this.form.username,
              password: this.RememberEncrypt.encrypt(this.form.password),
              account: this.form.account,
              usernameEncrypt: this.form.usernameEncrypt,
            });
            setStorage(this.useOptions.rememberKey, JSON.stringify(userList));
          } else if (recordIdx !== -1) {
            userList.splice(recordIdx, 1);
            setStorage(this.useOptions.rememberKey, JSON.stringify(userList));
          }
          // 回调
          if (this.useOptions.loginCallback && typeof this.useOptions.loginCallback === 'function') {
            this.useOptions.loginCallback(result, ACCOUNT_TYPE);
          }
          // 登录成功打点
          logger.event({
            actionType: 'login_success',
            module: this.form.loginType,
          });
        },
        (result, isNeedImgCaptcha) => { // 登录失败
          this.isLoading = false;
          // const msgTxt = msg || '网络异常，登录失败';
          // if (isNeedImgCaptcha && msg.indexOf('验证码') > -1) {
          //   this.tips.imgCaptcha = msgTxt;
          // } else {
          //   this.tips.password = msgTxt;
          // }
          this.errorTxt = result && result.errorMessage ? result.errorMessage : '网络异常，登录失败';
          // 刷新验证码
          if (isNeedImgCaptcha) {
            this.isNeedImgCaptcha = isNeedImgCaptcha;
            this.refreshImgCaptcha();
          }
          // 回调
          if (this.useOptions.loginCallback && typeof this.useOptions.loginCallback === 'function') {
            this.useOptions.loginCallback(result, ACCOUNT_TYPE);
          }
          // 登录失败打点
          logger.event({
            actionType: 'login_fail',
            module: this.form.loginType,
            eventLabel: this.errorTxt,
          });
        },
      );
      // 登录按钮点击打点
      logger.click({
        actionType: 'login_btn',
        module: this.form.loginType,
      });
    },
    // 显隐密码
    togglePwd(isShow) {
      this.showPwd = isShow;
    },
    // 记住我
    rememberMe(isRemember) {
      this.isRememberChecked = isRemember;
    },
    // 账号输入处理逻辑
    dueUsername(e) {
      // console.log(e);
      if (e.keyCode === 8
      || (e.keyCode !== 8 && this.form.username.length === 1)
      || e.type === 'paste') {
        this.form.password = '';
        this.form.account = '';
        this.form.usernameEncrypt = '';
        this.tips.password = '';
        this.tips.account = '';
      }
      // 实时校验
      if (this.useOptions.isRealtimeCheck) {
        this.checkUsername();
        if (!this.form.password) {
          this.tips.password = '';
        }
        if (!this.form.imgCaptcha) {
          this.tips.imgCaptcha = '';
        }
      }
    },
    // 密码输入处理逻辑
    duePassword(e) {
      if (e.keyCode === 13) {
        this.toLogin();
      } else if (this.useOptions.isRealtimeCheck) { // 实时校验
        this.checkPassword();
      }
    },
    // 验证码输入处理逻辑
    dueImgCaptcha(e) {
      if (e.keyCode === 13) {
        this.toLogin();
      } else if (this.useOptions.isRealtimeCheck) { // 实时校验
        this.checkImgCaptcha();
      }
    },
    // 选择账号回调
    selectAccount(item) {
      this.form.account = item.userNameForShow;
      this.form.usernameEncrypt = item.userName;
    },
    // 清除信息
    clearUsername() {
      this.form.username = '';
      this.tips.username = '';
    },
    clearPassword() {
      this.form.password = '';
      this.tips.password = '';
    },
    clearImgCaptcha() {
      this.form.imgCaptcha = '';
      this.tips.imgCaptcha = '';
    },
    // 选择登录用户
    selectSuggestion(user) {
      this.form.username = user.username;
      this.form.password = this.RememberEncrypt.decrypt(user.password);
      this.form.account = user.account || '';
      this.form.usernameEncrypt = user.usernameEncrypt || '';
      this.isRememberChecked = true;
      this.focus.username = false;
      this.checkUsername(true, true);
      this.checkPassword();
    },
    // 删除记录
    delSuggesstionItem(user) {
      const delFunc = () => {
        let recordIdx = -1;
        this.rememberList.map((item, index) => {
          // 删除存储记录
          if (item.username === user.username) {
            recordIdx = index;
          }
          // 删除输入框记录
          if (this.form.username === user.username) {
            this.form.username = '';
            this.form.password = '';
          }
          return item;
        });
        if (recordIdx !== -1) {
          this.rememberList.splice(recordIdx, 1);
          setStorage(this.useOptions.rememberKey, JSON.stringify(this.rememberList));
        }
      };
      if (!this.useOptions.delRememberCallback) {
        delFunc();
        return;
      }
      this.useOptions.delRememberCallback(delFunc);
    },
    getRememberList() {
      let userList = [];
      try {
        userList = JSON.parse(getStorage(this.useOptions.rememberKey)) || [];
        userList = userList.reverse();
        // 读取记住的账号密码
        if (userList.length && userList[0].username && userList[0].password) {
          const pwd = this.RememberEncrypt.decrypt(userList[0].password);
          this.form.username = userList[0].username;
          this.form.password = pwd || userList[0].password;
          this.form.account = userList[0].account || '';
          this.form.usernameEncrypt = userList[0].usernameEncrypt || '';
          this.isRememberChecked = true;
          this.checkUsername(true, true);
        }
      } catch (err) {
        console.log(err); // eslint-disable-line
        userList = [];
      }
      return userList;
    },
    // 登录是否需要协议
    apiNeedAgreement() {
      if (!this.form.username) {
        return;
      }
      apiAgreement(
        this.graph,
        this.form.username,
        () => { // 需要勾选协议
          this.isNeedAgreement = true;
        },
        () => {
          this.isNeedAgreement = false;
        },
      );
    },
    // 登陆是否需要验证码
    isNeedCaptcha() {
      apiNeedCaptcha(this.graph, (isNeedImgCaptcha) => {
        this.isNeedImgCaptcha = isNeedImgCaptcha;
        if (isNeedImgCaptcha) {
          this.refreshImgCaptcha();
        }
      });
    },
    // 刷新图片验证码
    refreshImgCaptcha() {
      this.imgCaptchaUrl = `${this.graph}/getImgCaptcha?timestamp=${new Date().getTime()}`;
    },
    // 检验数据
    checkFormDataError() {
      const errUsername = unValidName(this.form.username);
      const errPwd = unValidPwd2(this.form.password);
      let errAccount = '';
      if (this.isNeedSelectAccount) {
        errAccount = unValidUserAccount(this.form.account);
      }
      let errCaptcha = '';
      if (this.isNeedImgCaptcha) {
        errCaptcha = unValidImgCaptcha(this.form.imgCaptcha);
      }
      let errAgreement = '';
      if (this.isNeedAgreement) {
        errAgreement = unValidAgreement(this.form.isAgreement);
      }
      return errUsername || errPwd || errAccount || errCaptcha || errAgreement;
    },
    checkUsername(isBlur, isForce) {
      // this.tips.username = unValidName(this.form.username);
      // this.tips.username = this.form.username ? '' : '账号不得为空';
      if ((this.focus.username && isBlur === true) || isForce) {
        setTimeout(() => {
          this.focus.username = false;
        }, 200);
        // 如果是手机号，查询对应的账号
        if (isMobilePhone(this.form.username)) {
          apiUserInfoByMobile(
            this.graph,
            this.form.username,
            this.form.loginType,
            (result) => { // 登录成功
              if (result && result.length > 1) {
                this.isNeedSelectAccount = true;
                this.accountItems = result;
                let item = result[0];
                // 记住当初选择的账号
                if (isForce && this.useOptions.isRemember && this.form.account) {
                  item = {
                    userName: this.form.usernameEncrypt,
                    userNameForShow: this.form.account,
                  };
                }
                this.$nextTick(() => {
                  this.$refs.ChangeAccount.selectItem(item);
                });
              } else {
                this.isNeedSelectAccount = false;
                this.accountItems = [];
              }
            },
            () => {
              this.isNeedSelectAccount = false;
              this.accountItems = [];
            },
          );
        } else {
          this.isNeedSelectAccount = false;
          this.accountItems = [];
        }
        // 检查是否需要勾选协议
        this.apiNeedAgreement();
      }
    },
    checkPassword(isBlur) {
      // this.tips.password = unValidPwd(this.form.password);
      // this.tips.password = this.form.password ? '' : '密码不得为空';
      if (this.focus.password && isBlur === true) {
        setTimeout(() => {
          this.focus.password = false;
        }, 200);
      }
    },
    checkAccount(isBlur) {
      // this.tips.account = this.form.account ? '' : '账号不能为空';
      if (this.focus.account && isBlur === true) {
        setTimeout(() => {
          this.focus.account = false;
        }, 200);
      }
    },
    checkImgCaptcha(isBlur) {
      // this.tips.imgCaptcha = unValidImgCaptcha(this.form.imgCaptcha);
      if (this.focus.imgCaptcha && isBlur === true) {
        setTimeout(() => {
          this.focus.imgCaptcha = false;
        }, 200);
      }
    },
    toggleAgreement(isCheck) {
      this.form.isAgreement = isCheck ? 1 : 0;
    },
  },
};
</script>

<style lang="scss" scoped>
@import './libs/mixin.scss';

.v-login-accout {
  position: relative;
  font-size: 16px;
  &.resize {
    li {
      margin-top: 27px;
      &.btn-li {
        margin-top: 20px;
      }
    }
  }
  ul {
    @include resetUl;
  }
  li {
    position: relative;
    margin-top: 34px;
    input {
      @include loginInput;
    }
    .label {
      @include loginLabel;
    }
    &.btn-li {
      margin-top: 30px;
    }
    &.captcha-li {
      @include captchaItem;
    }
    &.agreement-li,
    &.links-li {
      margin-top: 10px;
    }
  }
  .suggest-popop-status {
    position: absolute;
    right: 0;
    top: 12px;
    width: 24px;
    height: 24px;
    font-size: 16px;
    cursor: pointer;
    // @include imgSprites(-97px, -57px);
    background: url('./imgs/select_down.png') center no-repeat;
    background-size: 20px auto;
    &.on {
      // background-position: -5px -97px;
      background-image: url('./imgs/select_up.png');
    }
  }
  .suggest-popop-wrap {
    display: none;
    position: absolute;
    left: 0;
    top: $loginInputHei;
    width: 100%;
    z-index: 10;
    padding-top: 3px;
    &.show {
      display: block;
    }
    .suggest-popop {
      background: #fff;
      box-shadow: 0px 4px 12px 0px rgba(0,0,0,0.1);
      border-radius: 4px;
      max-height: 192px;
      overflow-y: auto;
      overflow-x: hidden;
      padding-bottom: 4px;
      li {
        position: relative;
        padding: 12px 8px;
        margin: 0;
        cursor: pointer;
        height: 24px;
        font-size:16px;
        color:rgba(0,0,0,0.65);
        line-height: 24px;
        &:hover {
          background: rgba(248,248,248,1);
        }
        i {
          position: absolute;
          right: 8px;
          top: 50%;
          margin-top: -10px;
          width: 20px;
          height: 20px;
          text-align: center;
          line-height: 20px;
          font-style: normal;
          color: rgba(0, 0, 0, 0.25);
          &:hover {
            color: $mainColor;
          }
        }
      }
    }
  }
  .btn {
    @include loginBtn;
    width: 180px;
    margin: 0 auto;
    .dot {
      @include dotAni;
    }
  }
}
</style>
